<template>
  <div class="v2026-panelbar-collapsebar">
    <button type="button" class="v2026-panelbar-collapse"
            @click="$emit('toggleCollapse')"
            :aria-label="ariaLabel"
            :title="ariaLabel">
      <span class="v2026-panelbar-mask v2026-panelbar-collapse__ico" aria-hidden="true"
            :style="maskStyle(icons.collapse)"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'panel-collapse-bar-v2026',
  props: {
    ariaLabel: {
      type: String,
      default: 'ย่อแผง'
    }
  },
  data () {
    return {
      icons: {
        collapse: require('@/assets/icons2026/arrow-right.svg')
      }
    }
  },
  methods: {
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-panelbar-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-panelbar-collapsebar {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  padding: var(--v2026-sp-2) var(--v2026-sp-3) 0;
}
.v2026-panelbar-collapse {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
}
.v2026-panelbar-collapse:hover {
  background: var(--v2026-surface-hover);
}
.v2026-panelbar-collapse:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-panelbar-collapse__ico {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-color-icon-idle);

  transform: rotate(180deg);
}
</style>
